import React from 'react';
import Typography from '@material-ui/core/Typography';

import Base from '../Base';

function PenaltyShotMissed({event, teams, periods, players}) {
  const scorer = players[event.player];
  const period = periods[event.period].name;
  const team = teams[scorer.team].id;
  
  return (
    <Base
      team={team}
      time={event.second}
      period={period}
      type="Penalty Shot Miss"
    >
      <Typography variant="body2">
        {JSON.stringify(event)}
      </Typography>
    </Base>
  )
}

export default PenaltyShotMissed;
